// Shared feature catalog used by both UltraAdmin "Özellik Yönetimi"
// and the public /subscription comparison table.
// Keep this in sync with the seed in backend/scripts (or wherever packages get features).

export const FEATURE_CATALOG = [
  { id: 'new_advance_request', name: 'Yeni Avans Talebi', category: 'Çekirdek' },
  { id: 'advance_approval', name: 'Avans Onaylama', category: 'Çekirdek' },
  { id: 'finance_approval', name: 'Finans Onayı', category: 'Çekirdek' },
  { id: 'advance_closing', name: 'Avans Kapatma', category: 'Çekirdek' },
  { id: 'expense_reporting', name: 'Masraf Raporlama', category: 'Raporlama' },
  { id: 'pending_approvals', name: 'Bekleyen Onaylar', category: 'İş Akışı' },
  { id: 'approved_advances', name: 'Onaylanan Avanslar', category: 'İş Akışı' },
  { id: 'closed_advances', name: 'Kapatılan Avanslar', category: 'Raporlama' },
  { id: 'current_account', name: 'Cari Hesap', category: 'Muhasebe' },
  { id: 'all_requests', name: 'Tüm Talepler', category: 'Raporlama' },
  { id: 'user_management', name: 'Kullanıcı Yönetimi', category: 'Yönetim' },
  { id: 'role_hierarchy', name: 'Rol Hiyerarşisi', category: 'Yönetim' },
  { id: 'category_management', name: 'Kategori Yönetimi', category: 'Yönetim' },
  { id: 'user_permissions', name: 'Kullanıcı İzinleri', category: 'Yönetim' },
  { id: 'role_permissions', name: 'Rol İzinleri', category: 'Yönetim' },
  { id: 'advance_rules', name: 'Avans Kuralları', category: 'Ayarlar' },
  { id: 'general_settings', name: 'Genel Ayarlar', category: 'Ayarlar' },
  { id: 'email_notifications', name: 'E-posta Bildirimleri', category: 'Bildirimler' },
  { id: 'whatsapp_integration', name: 'WhatsApp Entegrasyonu', category: 'Bildirimler' },
  { id: 'bulk_operations', name: 'Toplu İşlemler', category: 'Verimlilik' },
  { id: 'advanced_filtering', name: 'Gelişmiş Filtreleme', category: 'Verimlilik' },
  { id: 'excel_export', name: 'Excel Dışa Aktarma', category: 'Raporlama' },
  { id: 'pdf_export', name: 'PDF Dışa Aktarma', category: 'Raporlama' },
  { id: 'dashboard_analytics', name: 'Dashboard & Analitik', category: 'Analitik' },
  { id: 'mobile_responsive', name: 'Mobil Uyumlu', category: 'Erişim' },
  { id: 'api_access', name: 'API Entegrasyonu', category: 'Entegrasyon' },
  { id: 'custom_branding', name: 'Özel Markalama', category: 'Özelleştirme' },
  { id: 'priority_support', name: 'Öncelikli Destek', category: 'Destek' },
  { id: 'multi_currency', name: 'Çoklu Para Birimi', category: 'Gelişmiş' },
  { id: 'budget_tracking', name: 'Bütçe Takibi', category: 'Gelişmiş' },
  { id: 'messaging', name: 'Mesajlaşma', category: 'İletişim' },
  { id: 'expense_entry', name: 'Harcama Girişi (Solo)', category: 'Solo' },
  { id: 'personal_expenses', name: 'Tüm Harcamalarım', category: 'Solo' },
  { id: 'expense_dashboard', name: 'Harcama Dashboard', category: 'Solo' },
];

export const FEATURE_BY_ID = FEATURE_CATALOG.reduce((acc, f) => {
  acc[f.id] = f;
  return acc;
}, {});
